var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbarToggleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.75C0 0.551088 0.0790175 0.360322 0.21967 0.21967C0.360322 0.0790175 0.551088 0 0.75 0H15.25C15.4489 0 15.6397 0.0790175 15.7803 0.21967C15.921 0.360322 16 0.551088 16 0.75C16 0.948912 15.921 1.13968 15.7803 1.28033C15.6397 1.42098 15.4489 1.5 15.25 1.5H0.75C0.551088 1.5 0.360322 1.42098 0.21967 1.28033C0.0790175 1.13968 0 0.948912 0 0.75ZM0 5.75C0 5.55109 0.0790175 5.36032 0.21967 5.21967C0.360322 5.07902 0.551088 5 0.75 5H15.25C15.4489 5 15.6397 5.07902 15.7803 5.21967C15.921 5.36032 16 5.55109 16 5.75C16 5.94891 15.921 6.13968 15.7803 6.28033C15.6397 6.42098 15.4489 6.5 15.25 6.5H0.75C0.551088 6.5 0.360322 6.42098 0.21967 6.28033C0.0790175 6.13968 0 5.94891 0 5.75ZM0.75 10C0.551088 10 0.360322 10.079 0.21967 10.2197C0.0790175 10.3603 0 10.5511 0 10.75C0 10.9489 0.0790175 11.1397 0.21967 11.2803C0.360322 11.421 0.551088 11.5 0.75 11.5H15.25C15.4489 11.5 15.6397 11.421 15.7803 11.2803C15.921 11.1397 16 10.9489 16 10.75C16 10.5511 15.921 10.3603 15.7803 10.2197C15.6397 10.079 15.4489 10 15.25 10H0.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarToggleIcon);
export default __webpack_public_path__ + "static/media/navbarToggleIcon.9bc1b111f9c1930dab0ec595b9d93ae0.svg";
export { ForwardRef as ReactComponent };